import { isEligibleCanvasResult } from "@dashboardApi/apis/engagementCanvasEligible/validators";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { EligibleCanvasStepResponse, GetEligibleCanvasStepParams } from "./types";

export const getEligibleCanvas = reactQueryFetcherAdapter(
  cacheKey,
  async (
    signal,
    appGroupId: string,
    { query, limit = 250, interaction, selectedWorkflowId }: GetEligibleCanvasStepParams
  ): Promise<EligibleCanvasStepResponse> => {
    return fetch(
      `/engagement/canvas/${appGroupId}/eligible`,
      "GET",
      {
        query,
        limit,
        interaction,
        selected_workflow_id: selectedWorkflowId,
      },
      { signal }
    );
  },
  isEligibleCanvasResult
);
